<template>
  <div class="page">
    <div class="page-container">
      <template v-if="!applied">
        <div class="panel-body">
          <div class="page-title">制订项目阶段性计划</div>
          <div class="panel-info-section">
            <div v-if="data.checkResult === -1">
              <a-alert class="v-mb-sm no-border" type="error">
                <div slot="message">
                  <div class="font-md text-darkblue flex items-center">
                    <a-icon type="alert" class="v-mr-xs" />
                    提交的项目阶段性计划已被驳回
                  </div>
                  <div class="flex v-mt-xs">
                    <span class="text-right text-grey">审核意见：</span>
                    <span class="col text-red" v-html="$utils.convertToHtml(data.checkOpinion)"></span>
                  </div>
                </div>
              </a-alert>
            </div>
            <div class="panel-info-section-title">
              <a-icon type="caret-right" class="text-primary" />
              <span class="text-bold">阶段性计划基本信息</span>
            </div>
            <div class="w1200">
              <a-form-model class="form-sm" ref="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" :model="form">
                <a-row>
                  <a-col span="12">
                    <a-form-model-item :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        阶段性计划名称
                      </span>
                      <a-input v-model="form.planName" ref="planName" placeholder="计划名称" style="width: calc(100% - 10px)" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col span="12">
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        业务范围
                      </span>
                      <a-select placeholder="请选择" @change="onTypeChange" show-search v-model="form.projectType" style="width: 220px" allowClear ref="projectType">
                        <a-select-option :value="11">合作项目—公募合作</a-select-option>
                        <a-select-option :value="12">合作项目—专项基金</a-select-option>
                        <a-select-option :value="21">螺蛳壳改造</a-select-option>
                        <a-select-option :value="22">精灵书屋</a-select-option>
                        <a-select-option :value="23">公益人才</a-select-option>
                        <a-select-option :value="24">爱心100</a-select-option>
                        <a-select-option :value="25">其他项目</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col span="12">
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        实施时间
                      </span>
                      <a-range-picker v-model="form.dates" format="YYYY-MM-DD" value-format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onFormDateRangeChange" ref="datePicker" style="width: 220px" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="addr">
                      <span slot="label">实施地点</span>
                      <template v-if="addressList.length > 0">
                        <div class="flex items-center" v-for="(item, index) in addressList" :key="index">
                          <div style="width: calc(100% - 100px)">
                            <a-input-group compact>
                              <a-cascader changeOnSelect style="width: 320px" expand-trigger="hover" :show-search="{ cascaderFilter }" :options="districts" placeholder="选择地区" v-model="item.districts" :ref="`districts-${index}`" />
                              <a-input style="width: calc(100% - 330px)" placeholder="详细地址" allowClear v-model="item.addr" :ref="`addr-${index}`" />
                            </a-input-group>
                          </div>
                          <a-space>
                            <a-button size="small" type="primary" icon="plus" @click="onAddAddress(index + 1)"></a-button>
                            <a-button size="small" type="default" icon="close" @click="onRemoveAddress(index)"></a-button>
                          </a-space>
                        </div>
                      </template>
                      <a-button size="small" type="primary" icon="plus" @click="onAddAddress(0)" v-else>添加实施地点</a-button>
                    </a-form-model-item>
                  </a-col>
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                      <span slot="label">备注</span>
                      <a-textarea :auto-size="{ minRows: 4 }" v-model="form.remark" ref="remark" placeholder="请款说明" style="width: calc(100% - 10px)" />
                      <!-- <div class="ant-form-explain text-grey text-justify">项目的执行效果，35个汉字以内，该内容会展示在捐款前提示中</div> -->
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-form-model>
            </div>
            <!-- <div class="flex items-center">
              <a-space :size="4" class="v-mb-sm">
                <a-button size="small" icon="plus" type="indigo" @click="handleNewTask('append')">添加任务分类</a-button>
              </a-space>
            </div> -->
            <div class="panel-info-section-title">
              <div class="flex items-center">
                <a-icon type="caret-right" class="text-primary" />
                <span class="text-bold">阶段性计划任务明细</span>
                <div class="v-ml-auto">
                  <a-button size="small" icon="plus" type="indigo" @click="handleNewTask('append')">添加任务</a-button>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="col">
                <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :loading="loading" :expanded-row-keys.sync="expandedTableKeys" :pagination="false" :data-source="tasks" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
                  <a-table-column title="操作" data-index="action" :width="90" align="center">
                    <template slot-scope="text, record, index">
                      <a-space class="icon-actions" :size="2">
                        <span class="icon-action" title="编辑" @click="record.editing = true" v-if="!record.editing"><a-icon type="form" /></span>
                        <span class="icon-action" title="确定" @click="record.editing = false" v-else><a-icon type="check" /></span>
                        <!-- v-if="record.taskType == '-1' || record.taskType == '0'" -->
                        <a-dropdown placement="bottomLeft">
                          <span class="icon-action" title="添加"><a-icon type="plus" /></span>
                          <a-menu slot="overlay">
                            <template v-if="record.isRoot">
                              <a-menu-item key="before" @click="handleNewTask('before', record, index)">
                                <a-icon class="text-indigo" type="border-top" />
                                向前添加任务
                              </a-menu-item>
                              <a-menu-item key="after" @click="handleNewTask('after', record, index)">
                                <a-icon class="text-indigo" type="border-bottom" />
                                向后添加任务
                              </a-menu-item>
                              <a-menu-item key="append" @click="handleNewSubTask('append', record, index)">
                                <a-icon class="text-indigo" type="border-right" />
                                添加子任务
                              </a-menu-item>
                            </template>
                            <template v-else>
                              <a-menu-item key="before" @click="handleNewSubTask('before', record, index)">
                                <a-icon class="text-indigo" type="border-top" />
                                向前添加任务
                              </a-menu-item>
                              <a-menu-item key="after" @click="handleNewSubTask('after', record, index)">
                                <a-icon class="text-indigo" type="border-bottom" />
                                向后添加任务
                              </a-menu-item>
                            </template>
                          </a-menu>
                        </a-dropdown>
                        <span class="icon-action text-red" title="删除" @click="handleRemoveTask(record, index)"><a-icon type="delete" /></span>
                      </a-space>
                    </template>
                  </a-table-column>
                  <a-table-column data-index="taskName" :ellipsis="true" :width="360" align="left">
                    <span slot="title">
                      <i class="required-mark">*</i>
                      任务名称
                    </span>
                    <template slot-scope="text, record">
                      <div class="relative-position flex items-center" :style="{ display: 'inline-block', width: hasChildren ? `calc(100% - ${record.isRoot ? 25 : 45}px)` : '100%' }">
                        <a-input size="small" :placeholder="record.isRoot ? '任务分类名称' : '任务名称'" style="width: 100%" v-model="record.taskName" :ref="`taskName-${record.uid}`" v-if="record.editing" />
                        <span v-else>{{ record.taskName || '-' }}</span>
                        <a-tooltip placement="top" :title="record.isRoot ? '任务分类名称为空' : '任务名称为空'" v-if="!record.taskName || !record.taskName.trim()">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip>
                      </div>
                    </template>
                  </a-table-column>
                  <a-table-column data-index="taskType" :width="98" align="center" :ellipsis="true">
                    <span slot="title">
                      <i class="required-mark">*</i>
                      任务类型
                    </span>
                    <template slot-scope="text, record">
                      <div class="relative-position" v-if="!(record.children && record.children.length)">
                        <a-select size="small" placeholder="请选择" v-model="record.taskType" :ref="`taskType-${record.uid}`" style="width: 100%" v-if="record.editing">
                          <a-select-option value="活动">活动</a-select-option>
                          <a-select-option value="文档">文档</a-select-option>
                          <a-select-option value="其他">其他</a-select-option>
                        </a-select>
                        <span v-else>{{ record.taskType || '-' }}</span>
                        <a-tooltip placement="top" title="未设置任务类型" v-if="!record.taskType">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip>
                      </div>
                    </template>
                  </a-table-column>
                  <a-table-column data-index="range" :width="190" align="center" :ellipsis="true">
                    <span slot="title">
                      <i class="required-mark">*</i>
                      任务周期
                    </span>
                    <template slot-scope="text, record">
                      <div class="relative-position" v-if="!(record.children && record.children.length)">
                        <a-range-picker
                          size="small"
                          v-model="record.dates"
                          format="YYYY-MM-DD"
                          value-format="YYYY-MM-DD"
                          :placeholder="['开始日期', '结束日期']"
                          @change="(date, dateString) => onDateRangeChange(dateString, record)"
                          :ref="`datePicker-${record.uid}`"
                          style="width: 100%"
                          v-if="record.editing"
                        />
                        <span v-else>{{ record.startDate ? record.startDate + '~' + record.endDate : '-' }}</span>
                        <a-tooltip placement="top" title="未设置任务周期" v-if="!record.startDate">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip>
                      </div>
                      <span v-else>{{ record.startDate ? record.startDate + '~' + record.endDate : '' }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="历时（天）" data-index="period" :width="90" align="center">
                    <template slot-scope="text, record">
                      <span v-if="record.startDate && record.endDate">{{ $utils.diffDays(record.startDate, record.endDate) }}d</span>
                      <span v-else>-</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="备注" data-index="remark" align="left">
                    <template slot-scope="text, record" v-if="!(record.children && record.children.length)">
                      <a-input size="small" v-model="record.remark" style="width: 100%" v-if="record.editing" />
                      <span v-else>{{ record.remark }}</span>
                    </template>
                  </a-table-column>
                </a-table>
              </div>
            </div>
            <div class="flex items-center v-mt-xs" v-if="tasks.length > 0">
              <span class="col font-xs">
                提示：
                <i class="text-red fa fa-exclamation-circle" aria-hidden="true"></i>
                表示项不符合要求，提交至审核时有
                <i class="text-red fa fa-exclamation-circle" aria-hidden="true"></i>
                标志将无法提交。
              </span>
            </div>

            <template v-if="form.projectType">
              <div class="panel-info-section-title v-mt-md">
                <a-icon type="caret-right" class="text-primary" />
                <span class="text-bold">关联项目</span>
              </div>
              <a-table
                :loading="projectLoading"
                :dataSource="projects"
                :pagination="false"
                :rowSelection="{
                  selectedRowKeys,
                  onChange: onSelectChange,
                  fixed: true,
                  columnWidth: 50,
                }"
                :scroll="{ x: true }"
                rowKey="id"
                size="small"
                ellipsis
                class="text-no-wrap table-striped"
              >
                <a-table-column title="#" data-index="index" :width="45" align="center" fixed="left">
                  <template slot-scope="text, record, index">{{ index + 1 }}</template>
                </a-table-column>
                <a-table-column title="项目状态" data-index="state" align="left" :width="120" fixed="left">
                  <template slot-scope="text, record">
                    <span class="text-grey" v-if="text === -1">已终止</span>
                    <span class="text-red" v-else-if="text === 0">
                      <div class="line-1" v-if="record.reviewResult === 0">项目申请已驳回</div>
                      <div class="line-1" v-else>项目申请待提交</div>
                    </span>
                    <span class="text-red" v-else-if="text === 1">项目申请待审核</span>
                    <span class="text-red" v-else-if="text === 2">筹款申请待提交</span>
                    <span class="text-red" v-else-if="text === 3">筹款申请待审核</span>
                    <span class="text-red" v-else-if="text === 7">执行中</span>
                    <span class="text-red" v-else-if="text === 8">结项中</span>
                    <span class="text-red" v-else-if="text === 9">已结项</span>
                  </template>
                </a-table-column>
                <a-table-column title="项目名称" data-index="name" :width="260" :ellipsis="true" align="left" fixed="left">
                  <template slot-scope="text, record">
                    <router-link class="text-indigo hover-line" :title="text" :to="{ path: 'view', query: { id: record.id } }">{{ text || record.topic }}</router-link>
                  </template>
                </a-table-column>
                <a-table-column title="项目编号" data-index="code" :width="115" :ellipsis="true" align="left" fixed="left" />
                <template v-if="data.projectType == 11 || data.projectType == 12">
                  <a-table-column title="申请人" data-index="users[0].realName" :width="200" :ellipsis="true" align="left" />
                </template>
                <template v-else-if="data.projectType == 22">
                  <a-table-column title="山区学校" data-index="studyInfo.schoolName" :width="150" :ellipsis="true" align="left" />
                  <a-table-column title="合作伙伴单位" data-index="studyInfo.cooperatorName" :width="180" :ellipsis="true" align="left" />
                </template>
                <a-table-column title="项目类型" data-index="otherInfo.type" align="left" :width="80" v-else-if="data.projectType == 25">
                  <template slot-scope="text">
                    <span v-if="text === 1">突发事件</span>
                    <span v-else-if="text === 2">重大活动</span>
                  </template>
                </a-table-column>
                <a-table-column title="项目周期" data-index="range" :width="180" align="left">
                  <template slot-scope="text, record">
                    <span>
                      {{ record.startDate ? record.startDate.substring(0, 10) : '' }}
                      <template v-if="record.endDate">~ {{ record.endDate.substring(0, 10) }}</template>
                    </span>
                  </template>
                </a-table-column>
                <a-table-column title="已完成任务数" data-index="taskDone" :width="102" :ellipsis="true" align="right" />
                <a-table-column title="未完成任务数" data-index="taskTodo" :width="102" :ellipsis="true" align="right" />
                <a-table-column title="预算金额" data-index="raisedAmount" :width="119" align="right">
                  <template slot-scope="text, record">
                    <span>{{ $utils.thousands(record.raisedAmount) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="请款金额" data-index="appliedAmount" :width="119" align="right">
                  <template slot-scope="text, record">
                    <span>{{ $utils.thousands(record.appliedAmount) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="实际支出" data-index="expensedAmount" :width="119" align="right">
                  <template slot-scope="text, record">
                    <span>{{ $utils.thousands(record.expensedAmount) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="请款余额" data-index="remainApplyAmount" :width="119" align="right">
                  <template slot-scope="text, record">
                    <span>{{ $utils.thousands(record.remainApplyAmount) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="差额" data-index="remainAmount" :width="119" align="right">
                  <template slot-scope="text, record">
                    <span v-if="record.budgetAmount">{{ $utils.thousands(record.budgetAmount - record.expensedAmount) }}</span>
                    <span v-else>-</span>
                  </template>
                </a-table-column>
                <template v-if="data.projectType == 11 || data.projectType == 12">
                  <a-table-column title="管理费" data-index="manageAmount" :width="110" align="right">
                    <template slot-scope="text, record">
                      <span>{{ $utils.thousands(record.manageAmount) }}</span>
                    </template>
                  </a-table-column>
                </template>
                <template v-if="data.projectType == 21">
                  <a-table-column title="申请人(成年人)姓名" data-index="lskInfo.applicantName" :width="140" :ellipsis="true" align="left" />
                  <a-table-column title="申请人手机" data-index="lskInfo.applicantPhone" :width="100" :ellipsis="true" align="left" />
                  <a-table-column title="房屋地址" data-index="lskInfo.houseAddr" :width="250" :ellipsis="true" align="left" />
                </template>
                <template v-else-if="data.projectType == 22">
                  <a-table-column title="合作伙伴联系人" data-index="studyInfo.cooperatorContact" :width="120" :ellipsis="true" align="left" />
                  <a-table-column title="合作伙伴联系人手机" data-index="studyInfo.cooperatorPhone" :width="150" :ellipsis="true" align="left" />
                  <a-table-column title="书籍接收人" data-index="studyInfo.bookReceiverName" :width="100" :ellipsis="true" align="left" />
                  <a-table-column title="书籍接收人手机" data-index="studyInfo.bookReceiverPhone" :width="120" :ellipsis="true" align="left" />
                </template>
                <template v-else-if="data.projectType == 23">
                  <a-table-column title="培训班类型" data-index="talentInfo.classType" :ellipsis="true" align="left" />
                  <a-table-column title="课时数量" data-index="talentInfo.classHour" :width="80" align="right" />
                  <a-table-column title="主讲老师" data-index="talentInfo.teacher" :width="90" align="left" />
                  <a-table-column title="主讲老师手机" data-index="talentInfo.teacherPhone" :width="105" :ellipsis="true" align="left" />
                  <a-table-column title="授课方式" data-index="talentInfo.teachingMethod" :width="120" :ellipsis="true" align="left" />
                </template>
                <template v-else-if="data.projectType == 24">
                  <a-table-column title="被推荐人" data-index="loveInfo.referralName" :width="100" :ellipsis="true" align="left" />
                  <a-table-column title="被推荐人电话" data-index="loveInfo.referralPhone" :width="120" :ellipsis="true" align="left" />
                  <a-table-column title="被推荐家庭地址" data-index="loveInfo.referralAddr" :width="210" :ellipsis="true" align="left" />
                  <a-table-column title="推荐人" data-index="loveInfo.refferrerName" :width="100" :ellipsis="true" align="left" />
                  <a-table-column title="推荐人手机" data-index="loveInfo.refferrerPhone" :width="100" :ellipsis="true" align="left" />
                </template>
              </a-table>
            </template>
            <div class="text-center v-my-lg">
              <a-space>
                <template v-if="!data.taskState">
                  <a-button icon="check" type="indigo" key="draft" @click="handleConfirm(false)" :loading="saving">保存初稿</a-button>
                  <a-button icon="arrow-right" type="primary" key="submit" @click="handleConfirm(true)" :loading="saving">提交审核</a-button>
                </template>
                <a-button icon="left" type="default" key="back" @click="$router.go(-1)">返回</a-button>
              </a-space>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您制订的项目阶段性计划已提交审核，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="$router.push(`./detail?id=${stagePlanId}`)">查看计划详情</a-button>
            <a-button key="back" @click="$router.go(-1)">返回</a-button>
          </template>
        </a-result>
      </template>
    </div>
  </div>
</template>

<script>
import { listHzProject } from '@/api/project/funded'
import * as SchoolService from '@/api/project/school'
import * as houseService from '@/api/project/house'
import * as talentService from '@/api/project/talent'
import * as loveService from '@/api/project/love'
import * as otherService from '@/api/project/other'
import { getStagePlan, saveStagePlan } from '@/api/project/stageplan'
import { createNewTask, convertTasksToTableData, convertBudgetsToTableData } from '@/utils/data'
import alldistricts from '@/utils/districts'
export default {
  name: 'OtherPanDraft',
  data() {
    return {
      stagePlanId: +this.$route.query.id,
      loading: false,
      data: {},
      tasks: [],
      expandedTableKeys: [],
      saving: false,
      applied: false,
      showBudgetModal: false,
      budgets: [],
      budgetsTableData: [],
      expandedBudgetKeys: [],
      selectedBudgetKeys: [],
      currentRecord: {},
      form: {
        planName: '',
        projectType: undefined,
        dates: [],
        startDate: undefined,
        endDate: undefined,
        remark: '',
      },
      districts: alldistricts,
      addressList: [],
      projectLoading: false,
      selectedRowKeys: [],
      projects: [],
    }
  },
  computed: {
    hasChildren() {
      return this.tasks.some(item => item.children && item.children.length)
    },
  },
  watch: {
    $route() {
      this.init()
    },
    tasks: {
      handler(records) {
        records.forEach(record => {
          let rootStartDate = record.startDate,
            rootEndDate = record.endDate
          if (record.children) {
            record.children.forEach(({ startDate, endDate }) => {
              if (startDate && endDate) {
                if (!rootStartDate || this.$moment(startDate).valueOf() < this.$moment(rootStartDate).valueOf()) {
                  rootStartDate = startDate
                }
                if (!rootEndDate || this.$moment(endDate).valueOf() > this.$moment(rootEndDate).valueOf()) {
                  rootEndDate = endDate
                }
              }
            })
          }
          record.startDate = rootStartDate
          record.endDate = rootEndDate
        })
      },
      deep: true,
    },
    'form.projectType'(type) {
      // this.selectedRowKeys = []
      if (!type) {
        this.projects = []
      } else if (type == 11 || type == 12) {
        this.loadHzProjects(type)
      } else if (type == 21) {
        this.loadHouseProjects()
      } else if (type == 22) {
        this.loadSchoolProjects()
      } else if (type == 23) {
        this.loadTalentProjects()
      } else if (type == 24) {
        this.loadLoveProjects()
      } else if (type == 25) {
        this.loadOtherProjects()
      }
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.stagePlanId = +id
        this.load()
      } else {
        this.onAddAddress()
      }
    },
    load() {
      this.loading = true
      getStagePlan(this.stagePlanId).then(({ data }) => {
        if (data.success) {
          let { tasks = [], addresses = [], projectIds = [], planName, startDate, endDate, remark, projectType } = data.result
          let taskRecords = convertTasksToTableData(tasks)
          this.tasks = taskRecords
          this.expandedTableKeys = taskRecords.filter(d => d.children && d.children.length).map(d => d.uid)
          this.data = data.result
          this.form = {
            planName,
            startDate,
            endDate,
            dates: startDate && endDate ? [startDate, endDate] : [],
            remark,
            projectType,
          }
          this.selectedRowKeys = [...projectIds]
          console.log(this.selectedRowKeys)
          if (addresses.length > 0) {
            this.addressList = addresses.map(({ id, province, city, district, addr }) => {
              let districts = []
              if (province) {
                districts.push(province)
              }
              if (city) {
                districts.push(city)
              }
              if (district) {
                districts.push(district)
              }
              return {
                id,
                districts,
                addr,
              }
            })
          } else {
            this.onAddAddress()
          }
        }
        this.loading = false
      })
      // getTasks(id).then(({ data }) => {
      //   this.loading = false
      //   if (data.success) {
      //     let records = convertTasksToTableData(data.result)
      //     this.tasks = records
      //     this.expandedTableKeys = records.filter(d => d.children && d.children.length).map(d => d.uid)
      //   }
      // })
    },
    onTypeChange() {
      this.selectedRowKeys = []
      console.log('onTypeChange')
    },
    loadHzProjects(type) {
      this.projectLoading = true
      let params = {
        type,
        pageSize: -1,
      }
      listHzProject(params)
        .then(({ data }) => {
          if (data.success) {
            let { records } = data.result
            this.projects = records
          }
          this.projectLoading = false
        })
        .catch(() => {
          this.projectLoading = false
        })
    },
    loadHouseProjects() {
      this.projectLoading = true
      let params = {
        pageSize: -1,
      }
      houseService
        .listPrj(params)
        .then(({ data }) => {
          if (data.success) {
            let { records } = data.result
            this.projects = records
          }
          this.projectLoading = false
        })
        .catch(() => {
          this.projectLoading = false
        })
    },
    loadSchoolProjects() {
      this.projectLoading = true
      let params = {
        pageSize: -1,
      }
      SchoolService.listPrj(params)
        .then(({ data }) => {
          if (data.success) {
            let { records } = data.result
            this.projects = records
          }
          this.projectLoading = false
        })
        .catch(() => {
          this.projectLoading = false
        })
    },
    loadTalentProjects() {
      this.projectLoading = true
      let params = {
        pageSize: -1,
      }
      talentService
        .listPrj(params)
        .then(({ data }) => {
          if (data.success) {
            let { records } = data.result
            this.projects = records
          }
          this.projectLoading = false
        })
        .catch(() => {
          this.projectLoading = false
        })
    },
    loadLoveProjects() {
      this.projectLoading = true
      let params = {
        pageSize: -1,
      }
      loveService
        .listPrj(params)
        .then(({ data }) => {
          if (data.success) {
            let { records } = data.result
            this.projects = records
          }
          this.projectLoading = false
        })
        .catch(() => {
          this.projectLoading = false
        })
    },
    loadOtherProjects() {
      this.projectLoading = true
      let params = {
        pageSize: -1,
      }
      otherService
        .listPrj(params)
        .then(({ data }) => {
          if (data.success) {
            let { records } = data.result
            this.projects = records
          }
          this.projectLoading = false
        })
        .catch(() => {
          this.projectLoading = false
        })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log(this.selectedRowKeys, selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    onAddAddress(index = 0) {
      let len = this.addressList.length
      this.addressList.splice(index, 0, {
        seq: len + 1,
        districts: [],
        addr: '',
      })
    },
    onRemoveAddress(index) {
      this.addressList.splice(index, 1)
    },
    onDateRangeChange(dateString, record) {
      let [startDate, endDate] = dateString
      record.startDate = startDate
      record.endDate = endDate
    },
    onFormDateRangeChange(date, dateString) {
      let [startDate, endDate] = dateString
      this.form.startDate = startDate ? `${startDate} 00:00` : startDate
      this.form.endDate = endDate ? `${endDate} 00:00` : endDate
    },
    handleNewTask(action, task, index) {
      // let tasks = this.tasks
      let newItem = createNewTask()
      newItem.editing = true
      newItem.uid = this.$utils.uuid()
      newItem.isRoot = 1
      if (action == 'append') {
        this.tasks.push(newItem)
      } else {
        this.tasks.splice(action == 'before' ? index : index + 1, 0, newItem)
      }
    },
    handleNewSubTask(action, item, index) {
      let newItem = createNewTask()
      newItem.uid = this.$utils.uuid()
      newItem.isRoot = 0
      newItem.editing = true
      if (action == 'append') {
        newItem.puid = item.uid
        if (!item.children) {
          item.children = []
        }
        newItem.parent = item
        // newItem.professionStartDate = item.startDate
        item.children.push(newItem)
        this.tasks.splice(index, 1, { ...item })
        this.$nextTick(() => {
          this.expandedTableKeys.push(item.uid)
        })
      } else {
        let parent = this.tasks.find(d => d.uid == item.puid)
        newItem.parent = parent
        newItem.puid = parent.uid
        parent.children.splice(action == 'before' ? index : index + 1, 0, newItem)
      }
    },
    handleRemoveTask(item, index) {
      if (item.isRoot) {
        this.tasks.splice(index, 1)
      } else {
        let parent = this.tasks.find(d => d.uid == item.puid)
        parent.children.splice(index, 1)
        if (parent.children.length == 0) {
          parent.children = undefined
        }
      }
    },
    validTask(item) {
      let { uid, taskName, taskType, dates, children } = item
      if (!taskName || !taskName.trim()) {
        item.editing = true
        this.$message.warn('任务名称不能为空')
        this.$nextTick(() => {
          this.$refs[`taskName-${uid}`].focus()
        })
        return false
      }
      let hasChildren = children && children.length
      if (!hasChildren) {
        if (!taskType) {
          item.editing = true
          this.$message.warn('未设置任务类型')
          this.$nextTick(() => {
            this.$refs[`taskType-${uid}`].focus()
          })
          return false
        }
        if (dates.length == 0) {
          item.editing = true
          this.$message.warn('未设置任务周期')
          this.$nextTick(() => {
            this.$refs[`datePicker-${uid}`].focus()
          })
          return false
        }
      }
      return true
    },
    handleConfirm(nextStep) {
      this.$message.destroy()
      let { projectType, planName, dates } = this.form
      this.$message.destroy()
      if (planName.trim() === '') {
        this.$message.warning('请输入计划名称')
        this.$refs.planName.focus()
        return
      }
      if (!projectType) {
        this.$message.warning('请选择业务范围')
        this.$refs.projectType.focus()
        return
      }
      if (dates.length === 0) {
        this.$message.warning('请选择实施时间')
        this.$refs.datePicker.focus()
        return
      }
      // let { tasks, addressList } = this
      // let addresses = addressList.filter(item => item.districts[0])
      // if (addresses.length === 0) {
      //   this.$message.warning('请选择项目实施地点')
      //   if (this.$refs['districts-0'] && this.$refs['districts-0'][0]) {
      //     this.$refs['districts-0'][0].focus()
      //   }
      //   return
      // }
      let { tasks } = this
      if (tasks.length === 0) {
        this.$message.warn('未添加任务')
        return
      }
      if (nextStep) {
        for (let index = 0; index < tasks.length; index++) {
          let item = tasks[index]
          if (!this.validTask(item)) {
            return false
          }
          if (item.children) {
            for (let i = 0; i < item.children.length; i++) {
              if (!this.validTask(item.children[i])) {
                return false
              }
            }
          }
        }
        if (this.selectedRowKeys.length == 0) {
          this.$message.warn('请添加关联项目')
          return
        }
      }
      this.$confirm({
        title: nextStep ? '确认提交项目阶段性计划？' : '确认保存初稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      let { stagePlanId } = this
      let { planName, projectType, startDate, endDate, remark } = this.form
      let tasks = this.tasks.map(({ taskId, taskName, taskType, ownerType = 1, remark, startDate, endDate, children }) => {
        let item = {
          taskId,
          taskName,
          taskType,
          ownerType,
          remark,
          startDate,
          endDate,
        }
        if (children && children.length) {
          item.children = children.map(d => ({
            taskId: d.taskId,
            taskPid: d.taskPid,
            taskName: d.taskName,
            taskType: d.taskType,
            ownerType: 1,
            startDate: d.startDate,
            endDate: d.endDate,
            remark: d.remark,
          }))
        }
        return item
      })
      let addresses = this.addressList.filter(item => item.districts[0])
      let params = {
        stagePlanId,
        planName: planName.trim(),
        projectType,
        startDate,
        endDate,
        remark: remark.trim(),
        tasks,
        addresses: addresses.map(({ id, districts, addr }) => ({ id, province: districts[0], city: districts[1], district: districts[2], addr })),
        projectIds: this.selectedRowKeys,
        nextStep,
      }
      this.saving = true
      saveStagePlan(params)
        .then(({ data }) => {
          if (data.success) {
            if (nextStep) {
              this.applied = true
              this.stagePlanId = data.result
            } else {
              this.$message.success('操作成功')
              this.$router.push('./list')
            }
          } else {
            this.$message.warning(data.msg)
          }
          this.saving = false
        })
        .catch(err => {
          if (err) {
            this.$message.warning(err)
          }
          this.saving = false
        })
    },
  },
  created() {
    this.init()
  },
}
</script>
